import { render, staticRenderFns } from "./CbxYesNoDefault.vue?vue&type=template&id=78608ce8&"
import script from "./CbxYesNoDefault.vue?vue&type=script&lang=ts&"
export * from "./CbxYesNoDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports